import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import numericInputHelper from '../../util/numericInputHelpers';
import Toggle from '../toggle/toggle';
import Corner from './corner/corner';
import { LinkProperties as LockedSymbol, UnlinkProperties as UnlockedSymbol } from '../../icons';
var CORNERS = {
  topLeft: 0,
  topRight: 1,
  bottomRight: 2,
  bottomLeft: 3
};
var getCornerIndex = function getCornerIndex(corner) {
  return CORNERS[corner];
};
var getValuesArray = function getValuesArray(value, unit) {
  var fallbackForInvalidValue = [0, 0, 0, 0];
  var regex = new RegExp(unit, 'g');
  var valuesArrayNoUnits = value.replace(regex, '').split(' ').map(Number);
  var result = valuesArrayNoUnits.length === 1 ? _.fill(Array(4), valuesArrayNoUnits[0]) : valuesArrayNoUnits;
  return _.some(result, function (item) {
    return isNaN(item);
  }) ? fallbackForInvalidValue : result;
};
var CornerRadiusInput = /*#__PURE__*/function (_React$Component) {
  function CornerRadiusInput(props) {
    var _this;
    _classCallCheck(this, CornerRadiusInput);
    _this = _callSuper(this, CornerRadiusInput, [props]);
    _this.state = {
      locked: _this.props.isInitiallyLocked
    };
    _this.getClassName = function () {
      return "".concat(_this.props.getClassName('control-corner-radius-input'), " ").concat(_this.state.locked ? 'locked' : 'unlocked');
    };
    _this.handleLinkClick = function (value) {
      _this.setState({
        locked: value
      });
    };
    _this.getCornerValue = function (corner) {
      var values = getValuesArray(_this.props.value, _this.props.unit);
      return values[getCornerIndex(corner)];
    };
    _this.getValidValue = function (value, corner) {
      var prevValue = _this.getCornerValue(corner);
      var _this$props = _this.props,
        min = _this$props.min,
        max = _this$props.max;
      return numericInputHelper.getValidNumericValue(value, prevValue, min, max);
    };
    _this.handleCornerChange = function (corner, e) {
      var newCornerValue = e.target.value;
      var diff = newCornerValue - _this.getCornerValue(corner);
      var newValue = _this.calcNewVal(diff, corner);
      _this.props.onChange(newValue);
    };
    _this.calcNewVal = function (diff, corner) {
      var value = _this.props.value;
      return _this.state.locked ? _this.calLockedVal(value, diff) : _this.calcUnlockedVal(value, diff, corner);
    };
    _this.calLockedVal = function (value, diff) {
      var cornerByIndex = _.invert(CORNERS);
      return getValuesArray(value, _this.props.unit).map(function (v, i) {
        var corner = cornerByIndex[i];
        return _this.getValidValue(_this.getCornerValue(corner) + diff, corner) + _this.props.unit;
      }).join(' ');
    };
    _this.calcUnlockedVal = function (value, diff, corner) {
      return _(value).thru(function () {
        return getValuesArray(value, _this.props.unit);
      }).assign(_defineProperty({}, getCornerIndex(corner), _this.getValidValue(_this.getCornerValue(corner) + diff, corner))).map(function (v) {
        return "".concat(v).concat(_this.props.unit);
      }).join(' ');
    };
    _this.onBlurTopLeft = _this.onBlurTopLeft.bind(_this);
    _this.onBlurTopRight = _this.onBlurTopRight.bind(_this);
    _this.onBlurBottomLeft = _this.onBlurBottomLeft.bind(_this);
    _this.onBlurBottomRight = _this.onBlurBottomRight.bind(_this);
    return _this;
  }
  _inherits(CornerRadiusInput, _React$Component);
  return _createClass(CornerRadiusInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.isInitiallyLocked !== this.props.isInitiallyLocked && this.state.locked !== this.props.isInitiallyLocked) {
        this.setState({
          locked: this.props.isInitiallyLocked
        });
      }
    }
  }, {
    key: "onBlurTopLeft",
    value: function onBlurTopLeft(e) {
      this.handleCornerChange('topLeft', e);
    }
  }, {
    key: "onBlurTopRight",
    value: function onBlurTopRight(e) {
      this.handleCornerChange('topRight', e);
    }
  }, {
    key: "onBlurBottomLeft",
    value: function onBlurBottomLeft(e) {
      this.handleCornerChange('bottomLeft', e);
    }
  }, {
    key: "onBlurBottomRight",
    value: function onBlurBottomRight(e) {
      this.handleCornerChange('bottomRight', e);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.getClassName()
      }, /*#__PURE__*/React.createElement("div", {
        className: "top"
      }, /*#__PURE__*/React.createElement(Corner, {
        unit: this.props.unit,
        onBlur: this.onBlurTopLeft,
        position: "top-left",
        min: this.props.min,
        max: this.props.max,
        value: this.getCornerValue('topLeft')
      }), /*#__PURE__*/React.createElement(Corner, {
        unit: this.props.unit,
        onBlur: this.onBlurTopRight,
        position: "top-right",
        min: this.props.min,
        max: this.props.max,
        value: this.getCornerValue('topRight')
      })), /*#__PURE__*/React.createElement(Toggle, {
        className: "link",
        value: this.state.locked,
        onChange: this.handleLinkClick
      }, this.state.locked ? /*#__PURE__*/React.createElement("span", {
        key: "lockedSymbol",
        className: "symbol lockedSymbol"
      }, /*#__PURE__*/React.createElement(LockedSymbol, null)) : null, this.state.locked ? null : /*#__PURE__*/React.createElement("span", {
        key: "unlockedSymbol",
        className: "symbol unlockedSymbol"
      }, /*#__PURE__*/React.createElement(UnlockedSymbol, null))), /*#__PURE__*/React.createElement("div", {
        className: "bottom"
      }, /*#__PURE__*/React.createElement(Corner, {
        unit: this.props.unit,
        onBlur: this.onBlurBottomLeft,
        position: "bottom-left",
        min: this.props.min,
        max: this.props.max,
        value: this.getCornerValue('bottomLeft')
      }), /*#__PURE__*/React.createElement(Corner, {
        unit: this.props.unit,
        onBlur: this.onBlurBottomRight,
        position: "bottom-right",
        min: this.props.min,
        max: this.props.max,
        value: this.getCornerValue('bottomRight')
      })));
    }
  }]);
}(React.Component);
CornerRadiusInput.displayName = 'CornerRadiusInput';
CornerRadiusInput.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** The corner radius value in defined units. The default unit is px. Can be in the format of '6' for all corners or splitted '1 2 2 1' */
  value: PropTypes.string.isRequired,
  /** a callback called with the new value when updating corner radius in the format of splitted corners, e.g. '1px 2px 2px 1px' */
  onChange: PropTypes.func.isRequired,
  /** is initiated with bounded values */
  isInitiallyLocked: PropTypes.bool,
  /** max corner radius input */
  max: PropTypes.number,
  /** min corner radius input */
  min: PropTypes.number,
  /** Units: percent, px, angle, seconds, or spx. or any string */
  unit: PropTypes.oneOfType([PropTypes.oneOf(['percent', 'px', 'angle', 'seconds', 'spx']), PropTypes.string])
};
CornerRadiusInput.defaultProps = {
  isInitiallyLocked: true,
  max: 999,
  min: 0,
  unit: 'px'
};
export default compose(CornerRadiusInput);